export enum ServerActionType {
  BookingMessage = 'booking.message',
  BookingReady = 'booking.ready',
}
